import { render } from "./amazonCart.vue?vue&type=template&id=6aee149f&scoped=true"
import script from "./amazonCart.vue?vue&type=script&lang=js"
export * from "./amazonCart.vue?vue&type=script&lang=js"

import "./amazonCart.vue?vue&type=style&index=0&id=6aee149f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aee149f"]])

export default __exports__